import styled, { keyframes, css } from "styled-components";

const rotate = keyframes`
  0% {
    transform: rotate(0);
    transform-origin: center center;
  }

  25% {
    transform: rotate(45deg);
    transform-origin: center center;
  }

  50% {
    transform: rotate(0);
    transform-origin: center center;
  }

  75% {
    transform: rotate(-45deg);
    transform-origin: center center;
  }

  100% {
    transform-origin: center center;
    transform: rotate(0deg);
  }
`

const shake = keyframes`
  0% {
    transform: translate(3px, 0);
  }
  50% {
    transform: translate(-3px, 0);
  }
  100% {
    transform: translate(0, 0);
  }
`

export const StyledMainContainer = styled.div`
  display: grid;

  border: 0.4px solid #BFC4CA;
  grid-auto-flow: column;
  grid-template-columns: auto 1fr;
  grid-column-gap: 11px;
  align-items: start;
  justify-items: start;
  grid-gap: 20px;
  padding: 30px;
  min-height: 200px;

  @media(max-width: 768) {
    min-height: 120px;
  }

  &:hover {
    border: 0.4px solid #96C169;
    div svg path {
      ${p => p.componentNum <= 2 ? css`animation: ${shake}  0.5s linear 1;` : css`animation: ${rotate}  2s linear 1;`}
    }
  }
`;

export const StyledIcon = styled.div`
  svg {
    width: 55px;
    height: 55px;
    
    path {
      ${p => p.isAnimated &&  (p.componentNum <= 2 ? css`animation: ${shake}  0.5s linear 2;` : css`animation: ${rotate}  2s linear 1;`)}
    }
  }
`;

export const StyledText = styled.div`
  display: grid;
  grid-row-gap: 8px;
`;
export const StyledTitle = styled.h1`
  color: #274B4D;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
`;
export const StyledDescription = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #545454;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
`;
